import "./Header.css";

export const Header = () => {
  return (
    <div className="landingBar" >
      <img alt="Drops" className="landingBarImg" src="/images/landing/Illustrations/Various_Illustrations/DROPS_LOGO_10_21.svg" />
    </div>
  );
}

